import { Flag } from 'lucide-react'

interface SectionFlagMarkerProps {
  /** Source label of the newest addendum touching this section (for the tooltip). */
  sourceLabel: string | null
}

/**
 * Compact amber flag shown beside a section's status dot when an accepted
 * addendum change touched a requirement mapped to that section. Used by both
 * OutlineNavigator and QuestionNavigator so the two navigators stay consistent.
 */
export function SectionFlagMarker({ sourceLabel }: SectionFlagMarkerProps) {
  const title = sourceLabel ? `Affected by ${sourceLabel}` : 'Affected by an addendum change'
  return (
    <span className="inline-flex shrink-0" title={title} aria-label={title}>
      <Flag className="h-3 w-3 text-[hsl(var(--status-warning))]" />
    </span>
  )
}
